import Const from 'constants';

const defaultState = {
    isDarkTheme: false,
};

export default function (state = defaultState, action) {
    if (action.type === Const.TOGGLE_THEME) {
        state = {...state, isDarkTheme: action.data};
    }

    return state;
}
